import { PAKETE, preisText, STEUERHINWEIS } from '@raporto/shared'

/**
 * Die Paketleiste – Basic, Pro und Premium in einer Zeile.
 *
 * Sie steht auf den Produktseiten, damit dort nicht nur «Preise ansehen»
 * steht, sondern auch, was es kostet. Name, für wen, Preis und das eine
 * Merkmal, das ein Paket vom kleineren unterscheidet – mehr nicht; der
 * vollständige Vergleich gehört auf die Preisseite.
 *
 * Alle Angaben kommen aus `PAKETE` in packages/shared. Eine zweite Liste
 * hier hiesse zwei Wahrheiten, und die zweite fällt beim ersten
 * Preiswechsel auf.
 */
export function Paketleiste({
  aufPreise,
  aufBestellen
}: {
  aufPreise: () => void
  aufBestellen?: (paket: string) => void
}): JSX.Element {
  return (
    <section className="rp-pg-abschnitt rp-pl" id="pakete">
      <div className="rp-pg-kapitel">
        <p className="rp-pg-augenbraue">Pakete</p>
        <h2>Drei Grössen, ein Produkt.</h2>
        <p>
          Der Funktionsumfang ist überall derselbe. Was sich unterscheidet, ist die Zahl der
          Benutzer und was auf der Baustelle dazukommt.
        </p>
      </div>

      <div className="rp-pl-reihe">
        {PAKETE.map((p) => (
          <article key={p.id} className="rp-pl-karte" data-empfohlen={p.empfohlen ? 'ja' : undefined}>
            {p.empfohlen && <span className="rp-pl-fahne">Beliebteste Wahl</span>}
            <h3>{p.name}</h3>
            <p className="rp-pl-wen">{p.fuerWen}</p>
            <p className="rp-pl-preis">
              <span>CHF</span>
              <b>{preisText(p.preisRp)}</b>
              <span>/ Monat</span>
            </p>
            <p className="rp-pl-steuer">{STEUERHINWEIS}</p>
            <p className="rp-pl-kern">{p.kern}</p>
            <button
              type="button"
              className={p.empfohlen ? 'rp-pg-knopf rp-pg-knopf-hell' : 'rp-pg-knopf rp-pg-knopf-glas'}
              aria-label={`${p.name} wählen`}
              onClick={() => (aufBestellen ? aufBestellen(p.id) : aufPreise())}
            >
              Wählen
            </button>
          </article>
        ))}
      </div>

      <div className="rp-pg-aktionen">
        <button type="button" className="rp-pg-knopf rp-pg-knopf-glas" onClick={aufPreise}>
          Alle Unterschiede vergleichen
        </button>
      </div>
    </section>
  )
}
